import { create } from 'zustand';
import { CatalogOverviewDto } from '../service/interface';

interface StoreState {
  catalogOverviewStore: Partial<CatalogOverviewDto>;
  setCatalogOverviewStore: (
    catalogOverviewStore: Partial<CatalogOverviewDto>,
  ) => void;
}

export const useCatalogOverviewStore = create<StoreState>((set, get) => {
  return {
    catalogOverviewStore: {},
    setCatalogOverviewStore: (
      catalogOverviewStore: Partial<CatalogOverviewDto>,
    ) => {
      set({ catalogOverviewStore });
    },
  };
});
